import weather from "../images/weather.webp";
import gkai from "../images/gkai.webp";
import camp from "../images/camp.webp";
import eventful from "../images/eventful.webp";
import lbdflix from "../images/lbdflix.webp";
import hirewave from "../images/hirewave.webp";

const portfolios = [
  {
    name: "LBDflix",
    skills: "ReactJS | NextJS | CSS | JavaScript | API | Open Source",
    image: lbdflix,
    desc: "LBDflix is a dynamic movie application that gives a variety of movies, movies details, and trailers. It is packed with movie collections for every movie lover and it also recommends movies to users. It is an open source project and open to developers, designers, writers, movie enthusiasts to collaborate and learn.",
    live: "https://lbdflix.vercel.app/",
    source: "https://github.com/lambeboluwatife/lbdflix",
    id: 1,
  },
  {
    name: "Hirewave",
    skills: "ReactJS | CSS | JavaScript | DexisJS",
    image: hirewave,
    desc: "Hirewave is an app that connect you with the best emerging talent, helping you build a dynamic team that drives growth and innovation.",
    live: "https://hirewave-merge.vercel.app/",
    source: "https://github.com/lambeboluwatife/hirewave-merge",
    id: 2,
  },
  {
    name: "Weather App",
    skills: "HTML5 | CSS | JavaScript | ReactJS | API",
    image: weather,
    desc: "Returns the weather data of your current location and you can search for weather data of any city in the world.",
    live: "https://react-weather-app-smoky-nu.vercel.app/",
    source: "https://github.com/lambeboluwatife/react-weather-app",
    id: 3,
  },
  {
    name: "Getting Killed And Injured (GKAI)",
    skills: "HTML5 | CSS | Bootstrap | JavaScript",
    image: gkai,
    desc: "Getting Killed And Injured (GKAI) is a logical game where users try to get random 4 digits.",
    live: "https://lambeboluwatife.github.io/GKAI/",
    source: "https://github.com/lambeboluwatife/GKAI",
    id: 4,
  },
  {
    name: "Eventful",
    skills:
      "HTML5 | CSS | JavaScript | ReactJS | NextJS | NodeJS | ExpressJS | MongoDB | Mongoose",
    image: eventful,
    desc: "Host and create events online from Conferences, Hackathons, Conventions, Exhibitions, Seminars, Festivals, Trade Fair, etc.",
    live: "https://eventful-lbd.netlify.app/",
    source: "https://github.com/lambeboluwatife/altschool-eventful-frontend",
    id: 5,
  },
  {
    name: "DanCamp",
    skills:
      "HTML5 | CSS | Bootstrap | JavaScript | EJS | NodeJS | ExpressJS | MongoDB | Mongoose",
    image: camp,
    desc: "DanCamp is a web app where users can add and view info of various campgrounds.",
    live: "https://dancamp.boluwatifelambe.repl.co/",
    source: "https://github.com/lambeboluwatife/DanCamp/tree/dani",
    id: 6,
  },
];

export default portfolios;
